import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Index } from './pages/Index.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Index />);
